export default function wrap_filters() {
  if ($('.ewd-uwcf-filters').length !== 0) {
    $('.product-filter-wrapper').appendTo('.woocommerce-products-header');
    $('.ewd-uwcf-filters').appendTo('.product-filter-wrapper');
    $('.product-filter-wrapper').show();

    //Gör så att alla olika produktkategorifilter är gömda bakom en dropdown till en början
    $('.ewd-uwcf-style-List').each(function() {
      var filterLanguageString = 'Filter by ';

      if (document.documentElement.lang == 'sv-SE') {
        filterLanguageString = 'Filtrera på ';
      }

      var categoryText = $(this).next('div').text().split(' ')[2];
      $(this).wrap('<div class="single-category"></div>');
      $(this).closest('.single-category').prepend('<span class="h4">' + filterLanguageString + categoryText + '</span>');

      $(this).closest('.single-category').click(function() {
        $(this).toggleClass('open');
      });

      if($('.ewd-uwcf-selected').length > 0) {
        $('.ewd-uwcf-selected').each(function() {
          $(this).closest('.single-category').addClass('open');
        });
      }
    });
  }
}
